import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ResourceContextProvider, usePermissions, } from 'react-admin';
import { canAccess } from './canAccess';
import { useAuthenticated } from './useAuthenticated';
/**
 * Override of react-admin's Resource component with RBAC built-in
 *
 * This component takes the same props as react-admin's Resource.
 *
 * Users must have the 'create' permission on the resource to see the create page.
 * Users must have the 'show' permission on the resource to see the show page.
 * Users must have the 'edit' permission on the resource to see the edit page.
 * Users must have the 'list' permission on the resource to see the list page.
 */
export var Resource = function (props) {
    var Create = props.create, Edit = props.edit, List = props.list, name = props.name, Show = props.show, children = props.children;
    var isAuthenticationLoading = useAuthenticated().isLoading;
    var _a = usePermissions(), isPermissionsLoading = _a.isLoading, permissions = _a.permissions;
    // if the authProvider hasn't returned, no need to render
    if (isAuthenticationLoading || isPermissionsLoading) {
        return null;
    }
    return (React.createElement(ResourceContextProvider, { value: name },
        React.createElement(Routes, null,
            Create &&
                canAccess({
                    permissions: permissions,
                    action: 'create',
                    resource: name,
                }) && (React.createElement(Route, { path: "create/*", element: React.isValidElement(Create) ? (Create) : typeof Create === 'function' ? (React.createElement(Create, null)) : null })),
            Show &&
                canAccess({
                    permissions: permissions,
                    action: 'show',
                    resource: name,
                }) && (React.createElement(Route, { path: ":id/show/*", element: React.isValidElement(Show) ? (Show) : typeof Show === 'function' ? (React.createElement(Show, null)) : null })),
            Edit &&
                canAccess({
                    permissions: permissions,
                    action: 'edit',
                    resource: name,
                }) && (React.createElement(Route, { path: ":id/*", element: React.isValidElement(Edit) ? (Edit) : typeof Edit === 'function' ? (React.createElement(Edit, null)) : null })),
            List &&
                canAccess({
                    permissions: permissions,
                    action: 'list',
                    resource: name,
                }) && (React.createElement(Route, { path: "/*", element: React.isValidElement(List) ? (List) : typeof List === 'function' ? (React.createElement(List, null)) : null })),
            children)));
};
Resource.raName = 'Resource';
Resource.registerResource = function (_a, permissions) {
    var create = _a.create, edit = _a.edit, icon = _a.icon, list = _a.list, name = _a.name, options = _a.options, show = _a.show, recordRepresentation = _a.recordRepresentation;
    return ({
        name: name,
        options: options,
        hasList: !!list &&
            canAccess({
                permissions: permissions,
                action: 'list',
                resource: name,
            }),
        hasCreate: !!create &&
            canAccess({
                permissions: permissions,
                action: 'create',
                resource: name,
            }),
        hasEdit: !!edit &&
            canAccess({
                permissions: permissions,
                action: 'edit',
                resource: name,
            }),
        hasShow: !!show &&
            canAccess({
                permissions: permissions,
                action: 'show',
                resource: name,
            }),
        icon: icon,
        recordRepresentation: recordRepresentation,
    });
};
